<ng-form class="k-form k-form-md" [formGroup]="appGaugePadProtectionData">
    <fieldset>
      <legend style="border-bottom: 1px solid #e2e8f0;">Gauge Protection</legend>
      <div class="row">
        <div class="col-sm-12">
          <kendo-formfield>
            <kendo-label text="Gauge Pad Protection"></kendo-label>
            <kendo-multiselect
              formControlName="selectedProtections"
              [data]="options$"
              textField="value"
              valueField="value"
              [valuePrimitive]="true"
              [filterable]="true"
              placeholder="Select gauge pad protections...">
            </kendo-multiselect>
            <kendo-formhint style="color:darkcyan;">Select one or more gauge pad protections</kendo-formhint>
          </kendo-formfield>
        </div>
      </div>
    </fieldset>
  </ng-form>